import React, { useState, useRef, useEffect } from "react";
import styles from "./index.module.css";
import { useAppDispatch } from "../slice/hooks";
import { setActiveCategory } from "../slice/category-slice";

function CategoryList({ categories, handleCategoryChange, activeCategory }) {
  // const [activeCategory, setActiveCategory] = useState(initialCategory || null);
  const categoryRef = useRef(null);
  const itemRefs = useRef({});
  const dispatch = useAppDispatch();

  useEffect(() => {
    if (activeCategory && itemRefs.current[activeCategory]) {
      itemRefs.current[activeCategory].scrollIntoView({
        behavior: "smooth",
        inline: "center",
        block: "nearest",
      });
    }
  }, [activeCategory]);

  return (
    <div ref={categoryRef} className={styles.categoryList}>
      {categories &&
        categories.map((i) => (
          <div
            key={i.productCategoryId}
            className={`${styles.categoryItem} ${
              activeCategory === i.productCategoryId ? styles.active : ""
            }`}
            ref={(el) => (itemRefs.current[i.productCategoryId] = el)}
            onClick={(e) => {
              e.stopPropagation(); // Prevent event bubbling
              const newActiveCategory =
                activeCategory === i.productCategoryId
                  ? null
                  : i.productCategoryId;

              // setActiveCategory(newActiveCategory); // Toggle active category
              dispatch(setActiveCategory(newActiveCategory));
              handleCategoryChange(newActiveCategory); // Pass category or null (if deselected)
            }}
          >
            {i.name}
          </div>
        ))}
    </div>
  );
}

export default CategoryList;
